<template>
  <div class="ewe-page">
    <TextbookPageNav
      v-if="textbookId"
      :barcode="textbookId"
      active-tab="words"
    />

    <APageHead sub="교재 단어·표현·문장을 관리합니다.">
      <template #title>
        단어 및 표현 관리
        <TextbookHeadTitle v-if="textbookId" :barcode="textbookId" />
      </template>
    </APageHead>

    <ACard body-flush>
      <div class="ewe-page__tabs">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          type="button"
          :class="['ewe-page__tab', { 'is-active': activeTab === tab.id }]"
          @click="activeTab = tab.id"
        >
          <i class="material-icons-round ewe-page__tab-icon">{{ tab.icon }}</i>
          <div class="ewe-page__tab-text">
            <span class="ewe-page__tab-label">{{ tab.label }}</span>
            <small class="ewe-page__tab-sub">{{ tab.sublabel }}</small>
          </div>
        </button>
      </div>

      <div class="ewe-page__content">
        <transition name="fade" mode="out-in">
          <WordsManager
            v-if="activeTab === 'words'"
            key="words"
            ref="wordsManager"
            :textbook-id="textbookId"
          />
          <ExpressionsManager
            v-else-if="activeTab === 'expressions'"
            key="expressions"
            ref="expressionsManager"
            :textbook-id="textbookId"
          />
          <SentencesManager
            v-else-if="activeTab === 'sentences'"
            key="sentences"
            ref="sentencesManager"
            :textbook-id="textbookId"
          />
        </transition>
      </div>
    </ACard>
  </div>
</template>

<script>
import WordsManager from "@/components/AiAgentData/WordsManager.vue";
import ExpressionsManager from "@/components/AiAgentData/ExpressionsManager.vue";
import SentencesManager from "@/components/AiAgentData/SentencesManager.vue";
import TextbookPageNav from "@/components/TextbookPageNav.vue";
import TextbookHeadTitle from "@/components/TextbookHeadTitle.vue";
import APageHead from "@/components/Pineapple/APageHead.vue";
import ACard from "@/components/Pineapple/ACard.vue";

export default {
  name: "EditWordsAndExpressions",
  components: { WordsManager, ExpressionsManager, SentencesManager, TextbookPageNav, TextbookHeadTitle, APageHead, ACard },
  data() {
    return {
      activeTab: "words",
      textbookId: null,
      tabs: [
        { id: "words", label: "단어", sublabel: "Words", icon: "menu_book" },
        { id: "expressions", label: "표현", sublabel: "Expressions", icon: "chat_bubble" },
        { id: "sentences", label: "문장", sublabel: "Sentences", icon: "subject" },
      ],
    };
  },
  watch: {
    activeTab(newTab) {
      this.$nextTick(() => {
        const manager = this.$refs[`${newTab}Manager`];
        if (manager && manager.loadData) manager.loadData();
      });
    },
  },
  mounted() {
    const tab = this.$route.query.tab;
    if (tab && ["words", "expressions", "sentences"].includes(tab)) this.activeTab = tab;
    this.textbookId = this.$route.query.barcode;
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pineapple";

.ewe-page {
  display: flex;
  flex-direction: column;
  gap: 20px;

  &__tabs {
    display: flex;
    gap: 8px;
    padding: 14px 16px;
    background: $p-panel-alt;
    border-bottom: 1px solid $p-line;

    @media (max-width: 640px) {
      flex-direction: column;
    }
  }

  &__tab {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 14px;
    background: $p-panel;
    border: 1px solid $p-line;
    border-radius: $p-radius-md;
    color: $p-ink-mid;
    cursor: pointer;
    transition: all $p-dur $p-ease;

    &:hover {
      border-color: $p-line-hard;
      background: $p-panel-alt;
    }

    &.is-active {
      background: $p-ink;
      border-color: $p-ink;
      color: $p-point;

      .ewe-page__tab-icon {
        background: $p-point;
        color: $p-ink;
      }
    }
  }

  &__tab-icon {
    width: 36px;
    height: 36px;
    background: $p-panel-alt;
    color: $p-point-deep;
    border-radius: $p-radius-sm;
    display: inline-grid;
    place-items: center;
    font-size: 20px !important;
    transition: all $p-dur $p-ease;
  }

  &__tab-text {
    display: flex;
    flex-direction: column;
    text-align: left;
  }

  &__tab-label {
    font-size: 13px;
    font-weight: 800;
  }

  &__tab-sub {
    font-size: 10px;
    opacity: 0.7;
    font-family: $p-font-mono;
  }

  &__content {
    padding: 20px 22px;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.18s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
